import React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '../utils';

const InteractionTip = ({ message, variant = 'indigo' }) => {
  const variants = {
    purple: {
      icon: 'text-purple-400',
      text: 'text-purple-400'
    },
    green: {
      icon: 'text-green-500',
      text: 'text-gray-400'
    },
    indigo: {
      icon: 'text-brand-indigo',
      text: 'text-brand-indigo'
    },
    orange: {
      icon: 'text-brand-accent',
      text: 'text-brand-accent'
    }
  };

  const style = variants[variant] || variants.indigo;

  return (
    <div className="flex items-center gap-2 mb-4 px-1 group">
      <Sparkles size={12} className={cn("shrink-0 transition-transform group-hover:scale-125", style.icon)} />
      <p className={cn("text-[10px] font-bold uppercase tracking-widest opacity-80 leading-relaxed", style.text)}>
        Tip: {message}
      </p>
    </div>
  );
};

export default InteractionTip;
